import { render, staticRenderFns } from "./ComoFunciona.vue?vue&type=template&id=69dc4c18"
import script from "./ComoFunciona.vue?vue&type=script&lang=js"
export * from "./ComoFunciona.vue?vue&type=script&lang=js"
import style0 from "./ComoFunciona.vue?vue&type=style&index=0&id=69dc4c18&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dc4c18')) {
      api.createRecord('69dc4c18', component.options)
    } else {
      api.reload('69dc4c18', component.options)
    }
    module.hot.accept("./ComoFunciona.vue?vue&type=template&id=69dc4c18", function () {
      api.rerender('69dc4c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/landingPage/ComoFunciona.vue"
export default component.exports